import React, { useContext } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import Card, { Section, Prose } from 'app/src/elements/Card';
import ClientContext from 'app/src/contexts/ClientContext';
import { Title, Subtitle, Text, Hint } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';

const Container = styled(View)`
  padding-top: 8px;
`;

const WelcomeText = styled(Text)`
  font-size: 18px;
  color: ${colors.textLight};
  margin-top: 8px;
  margin-bottom: 24px;
`;

const QuickAction = styled(Text)`
  color: ${colors.link};
  font-size: 16px;
  font-weight: 500;
`;

const QuickActionRow = styled(View)`
  flex-direction: row;
  gap: 24px;
  margin-top: 16px;
`;

const Home = () => {
  const { currentUser } = useContext(ClientContext);

  return (
    <Container>
      <Section>
        <Title>Welcome back</Title>
        <WelcomeText>
          {currentUser?.name}, ready to track some care?
        </WelcomeText>
      </Section>

      <Card>
        <Subtitle style={{ marginTop: 0 }}>Quick Actions</Subtitle>
        <Prose>
          <Text>
            Start tracking by adding a new event, or review your recent entries.
          </Text>
        </Prose>
        <QuickActionRow>
          <Link to="/events/new">
            <QuickAction>+ Add Event</QuickAction>
          </Link>
          <Link to="/events">
            <QuickAction>View Events</QuickAction>
          </Link>
        </QuickActionRow>
      </Card>

      <Card bordered>
        <Subtitle style={{ marginTop: 0 }}>Getting Started</Subtitle>
        <Prose>
          <Text>
            Set up your clients, event types, and things to start tracking care activities.
            Use the settings menu (gear icon) to configure your account.
          </Text>
        </Prose>
        <Hint style={{ marginTop: 12 }}>
          Tip: Create event types that match your care routines, like "Medication",
          "Meal", or "Symptom".
        </Hint>
      </Card>
    </Container>
  );
};

export default Home;
